import { l } from '@manychat/manyui'

import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNodeHeaderBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getContentNodeStatTable } from 'common/builder/components/chart/FlowChart/lib/utils/getContentNodeStatTable'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import {
  SmartDelayConfig,
  DEFAULT_ICON_RENDER_SIZE,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config/index'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { FlowChartSmartDelayNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartSmartDelayNode'
import { NodeType } from 'common/builder/constants/NodeType'
import { ISmartDelayNode } from 'common/builder/nodes/nodeInterfaces'
import { formatDelay } from 'common/builder/nodes/smartDelay/smartDelayNodeHelpers'
import { clearTextFromTags } from 'components/MCTextEditor/formatting/adapter'

import { wrapValue } from './helpers/wrapValue'

export const SmartDelayGenericConverterRule: ConverterRule<
  ISmartDelayNode,
  FlowChartSmartDelayNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: ISmartDelayNode) => entity?.nodeType === NodeType.SMART_DELAY,
  convert: (entity, { fields, timezone, rootNodeId, isStatByJSONAdsTrigger }) => {
    const formatedDelay = formatDelay(entity, wrapValue, timezone)
    const formatDelayText = clearTextFromTags(replaceFieldsInString(formatedDelay, fields))
    const isRootWithJSONAds = rootNodeId === entity.id && isStatByJSONAdsTrigger
    const icon = new FlowChartIconBuilder(SmartDelayConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE)
      .withColor(SmartDelayConfig.iconColor || '')
      .build()
    const header = new FlowChartNodeHeaderBuilder(entity.caption)
      .withColor(SmartDelayConfig.headerBackground)
      .withIcon(icon)
      .build()
    const nextStep = new FlowChartNextStepBuilder(entity.id)
      .withLabel(l.translate('Next Step'))
      .build()

    return {
      id: entity.id,
      nodeType: NodeType.SMART_DELAY,
      type: FlowChartNodeType.SMART_DELAY,
      onboardingElementId: '',
      data: {
        formatedDelay: formatDelayText,
        stats: getContentNodeStatTable(entity, { isRootWithJSONAds }),
        header,
        nextStep,
      },
    }
  },
}
